define('context/context',['require','backbone','marionette','context/user','context/basket','views/components/welcome_message/welcome_messages','collections/welcome_messages'],function (require) {
  var Backbone = require("backbone");
  require("marionette");

  var User = require("context/user");
  var Basket = require("context/basket");

  var WelcomeMessagesView = require("views/components/welcome_message/welcome_messages");
  var WelcomeMessagesCollection = require("collections/welcome_messages");

  return Backbone.Model.extend({
    pageTitle: "",
    welcomeMessages: [],
    currentRoute: null,

    initialize: function (callback) {
      this.readyCallback = function(_this){
        callback(_this);
        if(App.user !== null){
          App.vent.trigger("fetch-go-order-menus");
        }
      };

      this.registerLinkHandler();
      this.setupAppLocale();
      this.registerRequestInterceptor();

      this.start();

      this.listenTo(App.Router, "route", this._onRouteChange);
      this.listenTo(App.vent, "basket-updated", this._onBasketUpdate);
      this.listenTo(
        App.vent,
        "transaction-successful-clear-basket",
        this._onSuccessfulTransaction
      );
      this.listenTo(
        App.vent,
        "login-status-changed",
        this._onLoginStatusChange
      );
    },

    start: function () {
      // Check login status here
      var _this = this;

      this.initializeBasket();

      var token = "";

      $.ajax({
        url: App.Config.apiBase + "auth/me/",
        method: "get",
        beforeSend: function (xhr, settings) {
          if (App.DeploymentProfile == "dev") {
            xhr.setRequestHeader("Authorization", "Token " + token);
          }
        },
        success: function (response) {
          if (App.DeploymentProfile == "dev") {
            _this.performLogin(Object.assign(response, { token }));
          } else {
            _this.performLogin(response);
          }

          _this.getAppConstants(function () {
            _this.readyCallback(_this);
            
          });
        },
        error: function (xhr, ajaxOptions, thrownError) {
          _this.getAppConstants(function () {
            _this.readyCallback(_this);
          });

          _this.getWelcomeMessage();
        },
      });
    },

    login: function (parameters, successCallback, failureCallback) {
      var _this = this;

      $.ajax({
        url: App.Config.apiBase + "auth/login/",
        method: "post",
        data: parameters,
        success: function (response) {
          _this.performLogin(response);
          App.vent.trigger("fetch-go-order-menus");
          successCallback();
        },
        error: function (xhr, ajaxOptions, thrownError) {
          failureCallback(xhr);
        },
      });
    },

    performLogin: function (user) {
      App.user = new User(user);
      // Save user object in local storage
      localStorage.setItem("user", JSON.stringify(App.user));

      // Set user id for Google Analytics
      gtag("set", { user_id: App.utils.getUserTypeCode(user) + "_" + user.id });

      App.vent.trigger("login-status-changed");


    },

    logout: function () {
      var _this = this;

      $.ajax({
        url: App.Config.apiBase + "auth/logout/",
        method: "post",
        success: function (response) {
          _this.performLogout();
        },
      });
    },

    performLogout: function () {
      App.user = null;
      App.vent.trigger("login-status-changed");

      if (typeof Storage !== "undefined") {
        localStorage.removeItem("user");
      }

      this.redirect("/");
    },

    redirect: function (path) {
      // Do a refresh if same path
      if (App.utils.stripSlash(path) == Backbone.history.fragment) {
        Backbone.history.loadUrl(Backbone.history.fragment);
      } else {
        App.Router.navigate(path, { trigger: true });
      }
    },

    changeUrl: function (path) {
      App.Router.navigate(path, { trigger: false });
    },

    registerRequestInterceptor: function () {
      var _this = this;

      // jquery ajax setup
      $.ajaxSetup({
        cache: false,
        beforeSend: function (xhr, settings) {
          if (App.DeploymentProfile == "dev" && App.user) {
            xhr.setRequestHeader(
              "Authorization",
              "Token " + App.user.get("token")
            );
          }

          xhr.setRequestHeader("Accept-Language", _this.locale);
        },
        complete: function (xhr) {
          if (xhr.status == 403) {
            _this.performLogout();
          }
        },
      });

      // Backbone request setup
      var oldSync = Backbone.sync;
      Backbone.sync = function (method, model, options) {
        options.beforeSend = function (xhr) {
          if (App.DeploymentProfile == "dev" && App.user) {
            xhr.setRequestHeader(
              "Authorization",
              "Token " + App.user.get("token")
            );
          }

          xhr.setRequestHeader("Accept-Language", _this.locale);
        };

        options.complete = function (xhr) {
          if (xhr.status == 403) {
            _this.performLogout();
          }
        };

        return oldSync(method, model, options);
      };
    },

    registerLinkHandler: function () {
      var _this = this;

      $(document).on("click", "a", function (e) {
        if (!$(this).hasClass("out") && !$(this).hasClass("no-follow")) {
          e.preventDefault();

          if (!$(this).attr("data-toggle")) {
            if ($(this).attr("href") != "#") {
              // Scroll top on link click
              App.utils.hideContent();
              App.utils.scrollToTop();

              var href = $(this).attr("href");
              _this.redirect(href);
            }
          }
        }
      });
    },

    setupAppLocale: function () {
      var localeCookie = App.utils.getCookie("locale");
      if (localeCookie) {
        this.locale = localeCookie;
      } else {
        // If browser language is set to 'tr', use it, else use 'en', default language
        if (
          navigator &&
          navigator.language &&
          (navigator.language == "tr" || navigator.language == "tr-TR")
        ) {
          this.locale = "tr";
          document.cookie = "locale=tr";
        } else {
          this.locale = "en";
          document.cookie = "locale=en";
        }
      }
    },

    loadLocaleFile: function (callback) {
      var _this = this;

      // Register locale keys
      $.getJSON(
        App.Config.staticUrl + "locale/" + this.locale + ".json",
        function (langData) {
          _this.constants.localeData = langData;
          callback();
        }
      );
    },

    getAppConstants: function (callback) {
      var _this = this;

      var constants = null;
      if (typeof Storage !== "undefined") {
        // Try to get constants data from local storage
        var constantsData = localStorage.getItem("constants");

        if (constantsData) {
          try {
            constants = JSON.parse(constantsData);
          } catch (e) {
            // Invalid json. Remove stored value
            localStorage.removeItem("constants");
          }
        }
      }

      var requestData = {};
      if (constants) {
        requestData.version = constants.version;
      }

      $.ajax({
        url: App.Config.apiBase + "common/constants/",
        method: "get",
        data: requestData,
        success: function (response) {
          if (response.is_valid) {
            // Locally stored constants are valid, use them
            _this.constants = constants;
          } else {
            _this.constants = response.constants;

            // Save constants in local storage
            if (typeof Storage !== "undefined") {
              localStorage.setItem(
                "constants",
                JSON.stringify(response.constants)
              );
            }
          }

          // Load locale file
          _this.loadLocaleFile(function () {
            callback();
          });
        },
        error: function (xhr, ajaxOptions, thrownError) {
          _this.constants = {};

          // Load locale file
          _this.loadLocaleFile(function () {
            callback();
          });
        },
      });
    },

    getWelcomeMessage: function () {
      var _this = this;

      $.ajax({
        url: App.Config.apiBase + "welcome-messages/",
        method: "get",
        success: function (response) {
          _this.welcomeMessages = response.results;

          if (_this.currentRoute) {
            _this._processWelcomeMessage(_this.currentRoute);
          }
        },
      });
    },

    changePageTitle: function (pageTitle) {
      this.pageTitle = pageTitle;
      App.vent.trigger("page-title-changed");
    },

    initializeBasket: function () {
      if (typeof Storage !== "undefined") {
        var basketData = localStorage.getItem("basket");

        if (basketData) {
          try {
            this.basket = new Basket(JSON.parse(basketData));
          } catch (e) {
            this.basket = new Basket();

            // Invalid json. Remove stored value
            localStorage.removeItem("basket");
          }
        } else {
          this.basket = new Basket();
        }
      } else {
        this.basket = new Basket();
      }
      this.hasBasketRecurringProduct= false;
    },


    _onRouteChange: function (route) {
      this.currentRoute = route;

      if (
        App.contentRegion.currentView &&
        App.contentRegion.currentView.fullPage
      ) {
        $("body").removeClass("regular-page").addClass("full-page");
      } else {
        $("body").removeClass("full-page").addClass("regular-page");
      }

      // Process welcome messages
      this._processWelcomeMessage(route);

      // Send page view event to Google Analytics
      gtag("config", App.Config.analyticsId, {
        page_path: "/" + Backbone.history.fragment,
      });
    },

    _onLoginStatusChange: function () {
      this.getWelcomeMessage();

      if (App.user) {
        // Notify any possible parent window of login action
        App.utils.sendParentMessage({ login: true });
      }
    },

    _processWelcomeMessage: function (route) {
      App.messageRegion.reset();

      var pageMessages = this.welcomeMessages.filter(function (x) {
        return x.route == route;
      });

      if (pageMessages.length) {
        var messagesCollection = new WelcomeMessagesCollection(pageMessages);

        App.messageRegion.show(
          new WelcomeMessagesView({
            collection: messagesCollection,
          })
        );
      }
    },

    _onBasketUpdate: function () {
      // Save basket to local storage
      if (typeof Storage !== "undefined") {
        localStorage.setItem("basket", JSON.stringify(this.basket.attributes));
      }
    },

    _onSuccessfulTransaction: function () {
      // Clear basket data after successful transaction
      this.basket = new Basket();

      App.vent.trigger("basket-updated");
    },

  });
});

